import { useMemo } from 'react';

function isNativeColorInputSupported() {
  if (typeof document === 'undefined') return false;
  try {
    const input = document.createElement('input');
    input.setAttribute('type', 'color');
    return input.type === 'color';
  } catch {
    return false;
  }
}

export default function ColorPicker({ value, onChange, placeholder = '#7c3aed' }) {
  const supportsNativeColor = useMemo(() => isNativeColorInputSupported(), []);
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: supportsNativeColor ? '44px 1fr' : '1fr',
        gap: 10,
        alignItems: 'center',
      }}
    >
      {supportsNativeColor ? (
        <input
          type="color"
          className="ColorInput"
          value={String(value || '')}
          onChange={(e) => onChange?.(e.target.value)}
          aria-label="Choisir une couleur"
          title="Choisir une couleur"
        />
      ) : null}
      <input className="Input" value={String(value || '')} onChange={(e) => onChange?.(e.target.value)} placeholder={placeholder} />
    </div>
  );
}

